import { render, staticRenderFns } from "./GenerateFlowableForm.vue?vue&type=template&id=37d1cc32"
import script from "./GenerateFlowableForm.vue?vue&type=script&lang=js"
export * from "./GenerateFlowableForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37d1cc32')) {
      api.createRecord('37d1cc32', component.options)
    } else {
      api.reload('37d1cc32', component.options)
    }
    module.hot.accept("./GenerateFlowableForm.vue?vue&type=template&id=37d1cc32", function () {
      api.rerender('37d1cc32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/flowable/form/GenerateFlowableForm.vue"
export default component.exports